export default __webpack_public_path__ + "static/cafe_36069-20e8903c670f6d384ef6a8eaebdfa9fe.png";